<db-dialog-wrapper [dialog]="this" [animateShow]="false">
  <div class="db-delete-account-dialog">
    <div class="db-delete-account-dialog-header">
      <div class="dialog-title" [innerHTML]="'text_deleteAccountDialogTitle' | dbText">

      </div>
      <div class="dialog-subtitle mt10" [innerHTML]="'text_deleteAccountDialogSubtitle' | dbText">

      </div>
      <div class="dialog-warning-container">
        <i class="db-icon db-icon-ds-info-bg warn mr8"></i>
        <span [innerHTML]="'text_deleteAccountDialogInfo' | dbText"></span>
      </div>
    </div>
    <div class="db-delete-account-dialog-description" [innerHTML]="'text_deleteAccountDialogDesc' | dbText">
    </div>
    <div class="db-delete-account-dialog-input-container">
      <div class="input-label" [innerHTML]="'text_deleteAccountDialogInputLabel' | dbText">
      </div>
      <div class="ds-input-password-wrap mt8" [formGroup]="removeAccountForm">
        <input #password type="password" class="ds-input" placeholder="Password" formControlName="password"
               [ngClass]="{'error': removeAccountForm.touched && removeAccountForm?.get('password')?.errors}">
        <a class="ds-input-password-trigger"
           (click)="password.type = password.type === 'text' ? 'password' : 'text'; password.focus()">
          <i class="db-icon {{password.type === 'text' ? 'db-icon-ds-eye' : 'db-icon-ds-eye-cancel'}}"></i>
        </a>
        <span *ngIf="(removeAccountForm.touched && removeAccountForm?.get('password')?.errors) as errors"
              class="ds-input-error-msg"
              [innerHTML]="errors?.server || 'This field is required.'">
        </span>
      </div>
    </div>
    <div class="db-delete-account-dialog-button">
      <a class="ds-btn-blue"
         [ngClass]="{'ds-btn-disabled': removeAccountForm.invalid || loading}"
         (click)="removeUserAccount()">
        <span *ngIf="!loading">{{'text_delete' | dbText}}</span>
        <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
      </a>
    </div>
  </div>
</db-dialog-wrapper>
